module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" preserveAspectRatio=\"xMaxYMax meet\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"8\" cy=\"8\" r=\"7.5\" stroke=\"#74B74C\"/><rect width=\"2\" height=\"7\" x=\"7\" y=\"3\" fill=\"#74B74C\" fill-rule=\"nonzero\" rx=\"1\"/><circle cx=\"8\" cy=\"12\" r=\"1\" fill=\"#74B74C\" fill-rule=\"nonzero\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/success-sign.svg
// module id = Be+L
// module chunks = 5